export default function ModularSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Clock arithmetic that runs the internet
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Modular arithmetic is what happens when you treat numbers like a
        clock — 13 o'clock is 1 o'clock because they're the same modulo 12.
        It looks like a kid's puzzle and it's actually the foundation of
        modern cryptography. RSA encryption, the system that secures most
        web traffic, is built on the difficulty of one specific modular
        arithmetic problem (factoring a number mod a large prime). Modular
        teaches the concept directly: pick a modulus, pick a generator, see
        the orbit. The orbits that fill all of (n - 1) of the residues are
        called primitive roots and they are exactly the property RSA depends
        on.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        What's actually being tested
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Each round picks a small prime modulus (7, 11, 13, 23) and asks you
        to identify which numbers are primitive roots — generators whose
        powers cycle through every nonzero residue. 3 is a primitive root
        mod 7 (3¹=3, 3²=2, 3³=6, 3⁴=4, 3⁵=5, 3⁶=1 — all six nonzero
        residues appear). 2 is NOT a primitive root mod 7 (2¹=2, 2²=4,
        2³=1 — only three residues, then it loops early). The test suite
        verifies primitive-root detection across all the standard textbook
        cases (3 mod 7, 2 mod 11, 5 mod 23), so the game's answers match
        the math.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why this is worth your time
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Most students see modular arithmetic only in the context of "the
        clock problem" and never realize they've touched the same ideas
        that secure their banking and their messaging. The same concept
        of orbits and generators is used in elliptic-curve cryptography,
        in hash functions, in error-correcting codes. Playing with primitive
        roots in this game is a direct entry point to understanding how
        cryptography actually works — not the marketing version of it, the
        real version. It's also the gateway to abstract algebra, which is
        where math stops being about specific numbers and starts being about
        structure.
      </p>
    </>
  );
}
